import { CloseDrawerIcon } from "../ui-elements/svg-icons";
import {
  Box,
  Button,
  SelectChangeEvent,
  Stack,
  Typography,
} from "@mui/material";
import ModalContainer from "./modal-container";
import SelectInput from "./select";
import { LoadingButton } from "@mui/lab";
import { useMutation } from "@tanstack/react-query";
import { apiReportPost } from "../../api/post";
import { useNotificationService } from "../../hooks/notification";
import { useState } from "react";

export const FlagModalContents = ({
  handle_modal,
  open,
  post_id,
  toggle_flag,
  reported,
}: {
  open: boolean;
  reported: any;
  post_id: number;
  toggle_flag: () => void;
  handle_modal: () => void;
}) => {
  const { showNotification } = useNotificationService();
  const [reason, setReason] = useState("");
  const handle_reason = (value: string) => {
    setReason(value);
  };

  const mutation = useMutation({
    mutationFn: () => apiReportPost(post_id, reason),
    onSuccess: async (data) => {
      
      if (data?.status === "error") {
        if ("details" in data) {
          showNotification(data?.details ?? "An error has occurred", "error");
          return;
        }
        return;
      }
      if (data.status === 200) {
        
        showNotification("Post flagged successfully", "success");
        toggle_flag();
        handle_modal();
      }
    },
    onError: (error) => {
      showNotification("Server error", "error");
    },
  });

  const handle_flaged = () => {
    if (reason === "") {
      showNotification("Please select a reason", "warning");
    } else {
      mutation.mutate();
    }
  };
  return (
    <ModalContainer
      size="sm"
      openModal={open}
      handleModal={() => {}}
      sx={{}}
      fullWidth={false}
    >
      <Box
        sx={{
          background: "#fff",
          py: 2,
          px: 4,
          borderRadius: "16px",
          width: 250,
        }}
      >
        <Stack direction={"row"} justifyContent={"end"}>
          <Button sx={{ minWidth: 10 }} onClick={handle_modal}>
            <CloseDrawerIcon />
          </Button>
        </Stack>
        {!!reported && (
          <Typography
            variant="body1"
            sx={{
              color: "#7991A4",
              fontWeight: 500,
              lineHeight: 1.5,
              textAlign: "center",
            }}
          >
            This post has been flagged as {reported}
          </Typography>
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={"/assets/icons/onboarding/caution-icon.png"}
            style={{ width: 48, height: 48, marginTop: 10, marginBottom: 22 }}
          />
          <Typography variant="h5" sx={{ color: "#0A0B0A", fontWeight: 600 }}>
            Flag Post
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "#7991A4",
              fontWeight: 500,
              lineHeight: 1.5,
              textAlign: "center",
            }}
          >
            Kindly select a reason below
          </Typography>
        </Box>
        <SelectInput
          value={reason}
          onChange={(e) => handle_reason(e.target.value)}
          options={[
            { label: "Select reason", value: "" },
            { label: "Spam", value: "spam" },
            { label: "Harassment", value: "harassment" },
            { label: "Hate speech", value: "hate speech" },
            { label: "Fake news", value: "fake news" },
            { label: "Violence", value: "violence" },
          ]}
        />
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            my: 3,
            mx: "auto",
          }}
        >
          <LoadingButton
            variant="contained"
            color="primary"
            loading={mutation.isPending}
            sx={{
              borderRadius: 2,
              boxShadow: "none",
            }}
            onClick={handle_flaged}
          >
            flag post
          </LoadingButton>
        </Box>
      </Box>
    </ModalContainer>
  );
};
